export default "__VITE_ASSET__a6cb89ae__"